export type Ctx = Record<string, unknown>;
export const isRecord = (v: unknown): v is Record<string, unknown> =>
  v !== null && typeof v === "object";

export const getPath = <T = unknown>(ctx: unknown, path: string): T | undefined => {
  let acc: unknown = ctx;
  for (const key of path.split(".")) {
    if (!isRecord(acc) || !(key in acc)) return undefined;
    acc = acc[key as keyof typeof acc];
  }
  return acc as T | undefined;
}

export const isTruthy = (v: unknown) =>
  v !== "" && v !== false && v !== null && v !== undefined;

// Parse quoted literal or pass-through
export const coerceLiteral = (s: string) => {
  if (/^-?\d+(\.\d+)?$/.test(s)) return Number(s);
  if (s === "true") return true;
  if (s === "false") return false;
  if (s === "null") return null;
  if (s === "undefined") return undefined;
  const q = s[0], end = s[s.length - 1];
  if ((q === "'" && end === "'") || (q === '"' && end === '"')) return s.slice(1, -1);
  return s;
};

// Split by token, trim, drop empties
export const split = (raw: string, sep: string) =>
  raw.split(sep).map(s => s.trim())
    .filter(Boolean);